export default {
	name: 'Enheter',
	singular: 'Enhet',
	icon: 'tablet-alt',
    ownView: 'Devices',
	slug: 'devices',
	isCustom: true,
	access: ['superadmin', 'admin', 'reseller']
}